import React, { ReactElement, PropsWithChildren } from 'react'
import { Flex, Box, ThemeUIStyleObject } from 'theme-ui'
import { Svg } from 'ui'
import LogoBgIcon from 'images/organization/homepage/sections/solutions/logo-bg.svg'

export function StaticPageBody({
  children,
  sxChildrenWrapper,
  sxBody,
}: PropsWithChildren<{
  sxChildrenWrapper?: ThemeUIStyleObject
  sxBody?: ThemeUIStyleObject
}>): ReactElement {
  return (
    <Flex
      sx={{
        position: 'relative',
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        textAlign: 'center',
        mt: ['4rem', '7rem'],
        px: ['1.2rem', 0],
        ...sxBody,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: ['0rem', '2rem'],
          left: 0,
          width: '100%',
          height: ['21rem', '32rem'],
          background: ['turquoise20', 'aquamarine8'],
          filter: 'blur(150px)',
        }}
      />
      <Svg
        svg={LogoBgIcon}
        sx={{
          visibility: ['hidden', 'hidden', 'visible'],
          position: 'absolute',
          top: '-50rem',
          right: 0,
        }}
        descriptiveText="Decorative background logo"
      />
      <Flex
        sx={{
          flexDirection: 'column',
          width: ['100%', 'auto'],
          zIndex: 'zIndex5',
          ...sxChildrenWrapper,
        }}
      >
        {children}
      </Flex>
    </Flex>
  )
}
